export const SURVEYEFFORT = "survey_effort";
export const SURVEYBREADCRUMB = "survey_breadcrumb";
export const SURVEYPRIMARY = "survey_downed_bird";
export const SURVEYTERTIARY = "survey_downed_bird";
export const REFBREADCRUMB = "ref_breadcrumb_location";
export const SURVEYPRIMARYPHOTO = "survey_photo_downed_bird";
export const SURVEYSECONDARYPHOTO = "survey_photo_downed_bird";
export const SURVEYTERTIARYPHOTO = "survey_photo_downed_bird";
export const SURVEYSECONDARY = "survey_downed_bird";
export const tabTableMap = {
  "Downed Bird": SURVEYPRIMARY,
};
export const SURVEYEFFORTFIELDS = [
  { key: "id", type: "number" },
  { key: "incidental", type: "boolean" },
  { key: "survey_ts", type: "text", keyField: true },
  { key: "survey_tablet", type: "text", keyField: true },
];
export const SURVEYBREADCRUMBFIELDS = [
  { key: "id", type: "number" },
  { key: "survey_ts", type: "text", keyField: true },
  { key: "survey_tablet", type: "text", keyField: true },
  { key: "ts", type: "text", keyField: true },
  { key: "longitude_wgs84", type: "number" },
  { key: "latitude_wgs84", type: "number" },
];

export const SURVEYPRIMARYFIELDS = [
  { key: "id", type: "number" },
  { key: "survey_ts", type: "text", keyField: true },
  { key: "survey_tablet", type: "text", keyField: true },
  { key: "longitude_wgs84", type: "number" },
  { key: "latitude_wgs84", type: "number" },
  { key: "field_species_code", label: "Species", default: "", required: true },
  { key: "age_code", label: "Age", default: "U" },
  { key: "sex_code", label: "Sex", default: "U" },
  { key: "observation_ts", type: "text", label: "Timestamp", keyField: true },
  { key: "incident_ts", type: "text", label: "Timestamp" },
  { key: "ground_cover_height", type: "number", default: 0 },
  { key: "deck", type: "text", default: "n/data" },
  { key: "cabin", type: "text", default: "n/data" },
  { key: "vessel_name", type: "text", default: "n/data" },
  { key: "cloud_cover_percent", type: "number", default: 0 },
];
export const SURVEYSECONDARYFIELDS = [];

export const PHOTOFIELDS = [
  { key: "id", type: "number" },
  { key: "ts", type: "text", keyField: true },
];
